// Add to Cart Form
$(document).ready(function () {
  let addToCartFormSelector = "#add-to-cart-form",
    productOptionSelector = addToCartFormSelector + " [name*=option]";
    

  let productForm = {
onProductOptionChanged: function (event) {

  
  let $form = $(this).closest(addToCartFormSelector);
  let selectedVariant = productForm.getActiveVariant($form);

  // Trigger form change event with the selected variant
  $form.trigger("form:change", [selectedVariant]);

  // Log the selected variant for debugging
  console.log("Selected variant:", selectedVariant);

  // Display the image associated with the selected variant
  if (selectedVariant.featured_media && selectedVariant.featured_media.preview_image && selectedVariant.featured_media.preview_image.src) {
    $('.product-image').attr('src', selectedVariant.featured_media.preview_image.src);
  } else {
    $('.product-image').attr('src', 'default-image.jpg');
  }

  // Update the thumbnail image
  if (selectedVariant.featured_image && selectedVariant.featured_image.src) {
    $('#myImg').attr('src', selectedVariant.featured_image.src);
  } else {
    $('#myImg').attr('src', 'default-thumbnail.jpg');
  }

  // Update the slideshow to reflect the selected variant
  function updateSlideshowForVariant(variantId) {
  // Get all slides
  var slides = document.querySelectorAll('.mySlides');

  slides.forEach(function(slide) {
    // Show the slide if it matches the variantId
    if (slide.getAttribute('data-variant') === variantId.toString()) {
      slide.style.display = 'block';
    } else {
      slide.style.display = 'none';
    }
  });

  // Reset slideshow index to ensure the correct slide is shown
  slideIndex = 1;
  showDivs(slideIndex);
}

  updateSlideshowForVariant(selectedVariant.id);

  // Note: Custom label functionality is handled in the product template
},


getActiveVariant: function ($form) {
      let variants = JSON.parse(
          decodeURIComponent($form.attr("data-variants"))
        ),
        formData = $form.serializeArray(),
        formOptions = {
          option1: null,
          option2: null,
          option3: null,
        },
        selectedVariant = null;

      $.each(formData, function (index, item) {
        if (item.name.indexOf("option") !== -1) {
          formOptions[item.name] = item.value;
        }
      });

      $.each(variants, function (index, variant) {
        if (
          variant.option1 === formOptions.option1 &&
          variant.option2 === formOptions.option2 &&
          variant.option3 === formOptions.option3
        ) {
          selectedVariant = variant;
          return false;
        }
      });

      return selectedVariant;
    },

    validate: function (event, selectedVariant) {
      let $form = $(this),
        hasVariant = selectedVariant !== null,
        canAddToCart = hasVariant && selectedVariant.inventory_quantity > 0,
        $id = $form.find(".js-variant-id"),
        $addToCartButton = $form.find("#add-to-cart-button"),
        $price = $form.find(".js-price"),
       
        $priceHtmlFinal = $form.find(".js-price-final"),
        $quantityNumber = $form.find(".js-quantity-field-sticky").val(),
        formatedVariantPrice,
        priceHtml;

      if (hasVariant) {
        formatedVariantPrice = "€" + (selectedVariant.price / 100).toFixed(2);
        priceHtml = '<span class="money">' + formatedVariantPrice + "</span>";
        priceTotal = "€" + (selectedVariant.price / 100) * $quantityNumber;
        window.history.replaceState(
          null,
          null,
          "?variant=" + selectedVariant.id
        );
      } else {
        priceHtml = $price.attr("data-default-price").toFixed(2);
      }

      
      if (canAddToCart) {
        $id.val(selectedVariant.id);
        $addToCartButton.prop("disabled", false);
      } else {
        $id.val("");
        $addToCartButton.prop("disabled", true);
      }


      $price.html(priceHtml);
    },

    init: function () {
      $(document).on(
        "change",
        productOptionSelector,
        productForm.onProductOptionChanged
         

      );
      $(document).on(
        "form:change",
        addToCartFormSelector,
        productForm.validate
        // our new function
        //this._filterThumbnails(variant)
      );
    },
  };

  productForm.init();

  // Here I display the image that is associated with the variant that is choosen

  $(document).on('change'), productOptionSelector, function () {
    alert('esta a dar');
  }

  // Change on the Quantity Field Sticky


  $(document).on("change", ".js-quantity-field-sticky", function (event) {
    let $field = $(this),
      $form = $field.closest("form"),
      $quantityText = $form.find(".js-quantity-text-sticky"),
      shouldDisableMinus = parseInt(this.value) === 1,
      $minusButton = $form.find(".js-quantity-button-sticky.minus");

    $quantityText.text(this.value);

    if (shouldDisableMinus) {
      $minusButton.prop("disabled", true);
    } else if ($minusButton.prop("disabled") === true) {
      $minusButton.prop("disabled", false);
    }
  });

  $(document).on("click", ".js-quantity-button-sticky", function (event) {
    console.log("Quantity selector button clicked on product page");
    let $button = $(this),
      $form = $button.closest("form"),
      $quantity = $form.find(".js-quantity-field-sticky"),
      quantityValue = parseInt($quantity.val()),
      $variantPrice = $(".js-price").attr("data-variant-price"),
      $finalPrice = $(".js-price-final");

    if ($button.hasClass("plus")) {
      $quantity.val(quantityValue + 1).change();
      $finalPrice.text("€" + $quantity.val() * ($variantPrice / 100));
    } else if ($button.hasClass("minus")) {
      $quantity.val(quantityValue - 1).change();
      $finalPrice.text("€" + $quantity.val() * ($variantPrice / 100));
    }

    //console.log($variantPrice);
  });

  
  // Mini Cart

let miniCartContentSelector = ".js-mini-cart-contents";

let ajaxify = {
  onAddToCart: function (event) {
    event.preventDefault();

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: $(this).serialize(),
      dataType: "json",
      success: ajaxify.onCartUpdated,
      error: ajaxify.onError,
    });
  },

  
// Here is the cicle that runs when I add something to the cart
  onCartUpdated: function () {
    let $miniCartFieldset = $(miniCartContentSelector + " .js-cart-fieldset");
    $miniCartFieldset.prop("disabled", true);

    let url = "/cart";
    if (Shopify.locale == "en") url = "/en/cart";

    $.ajax({
      type: "GET",
      url: url,
      context: document.body,
      success: function (context) {
        let $dataCartContents = $(context).find(".js-cart-page-contents"),
          $upsellWrap = $dataCartContents.find("#upsell-wrap"),
          dataCartHtml = $dataCartContents.html(),
          dataCartItemCount = $dataCartContents.attr("data-cart-item-count"),
          $miniCartContents = $(miniCartContentSelector),
          $cartItemCount = $(".js-cart-item-count");

        $cartItemCount.text(dataCartItemCount);
        $miniCartContents.html(dataCartHtml);

        // Update the cart count info in the header
        $(".cart_count_info").text(dataCartItemCount);




// Function to handle gift wrap related operations
function handleGiftWrap() {
    // Retrieve gift wrap price and description from the mini cart data attributes
    var giftWrapPrice = $('#mini-cart').data('gift-wrap-price');
    var giftWrapDescription = $('#mini-cart').data('gift-wrap-description');

    // Creating HTML for gift wrap item
    var giftWrapItemHtml = `
        <div class="gift-wrap">
            <div class="left-side">
                <img src="https://cdn.shopify.com/s/files/1/0550/0964/0503/files/gift-wrap-icon.svg??v=${Date.now()}" onerror="this.src='https://cdn.shopify.com/s/files/1/0550/0964/0503/files/gift-wrap-icon.svg'">
                <p>${giftWrapDescription}</p>
            </div>
            <div class="right-side">
                <p>${giftWrapPrice}</p>
                <input type="checkbox" class="upsell-wrap" value="46378171990361">
            </div>
        </div>`;

    // Appending gift wrap item to mini cart
    $('.gift-wrap').remove(); // Remove existing gift wrap item if any
    $('div.subtotal').before(giftWrapItemHtml);

    // Bind the function to the checkbox change event
    $('.upsell-wrap').change(updateGiftWrap);
}

// Function to add or remove gift wrap based on checkbox state
function updateGiftWrap() {
    var isGiftWrapChecked = $(this).is(':checked');

    var wrapOption = {
        id: $(this).val(), // Get the product variant ID from the checkbox value
        quantity: isGiftWrapChecked ? 1 : 0, // Adjust quantity based on checkbox state
    };

    $.ajax({
        type: 'POST',
        url: isGiftWrapChecked ? '/cart/add.js' : '/cart/update.js',
        data: wrapOption,
        dataType: 'json',
        success: function (item) {
            // Handle the response if needed
            console.log('Wrap option ' + (isGiftWrapChecked ? 'added' : 'removed') + ' to/from cart:', item);
        },
        error: function (error) {
            // Handle the error if needed
            console.error('Error updating cart:', error);
        },
    });
}

// Call the gift wrap function
handleGiftWrap();



        
        if (parseInt(dataCartItemCount) > 0) {
          ajaxify.openCart();
        } else {
          ajaxify.closeCart();
        }

        
      },
    });
  },



  onError: function (XMLHttpRequest, textStatus) {
    let data = XMLHttpRequest.responseJSON;
    alert(data.status + " = " + data.message + ": " + data.description);
  },

  onCartButtonClick: function (event) {
    event.preventDefault();

    let isCartOpen = $("html").hasClass("mini-cart-open"),
      isInCart = window.location.href.indexOf("/cart") !== -1;

    if (!isCartOpen) {
      ajaxify.openCart();
    } else {
      ajaxify.closeCart();
    }
  },

  openCart: function () {
    $("html").addClass("mini-cart-open");
  },

  // closeCart: function () {
  //   $("html").removeClass("mini-cart-open");
  // },

  closeCart: function () {
  setTimeout(function() {
    $("html").removeClass("mini-cart-open");
  }, 800); // Adjust the delay time as needed (in milliseconds)
},


  init: function () {
    $(document).on("submit", addToCartFormSelector, ajaxify.onAddToCart);

    //$(document).on("change", "#upsell-wrap", ajaxify.onCheckboxChange);

    $(document).on("click", ".js-cart-link", ajaxify.onCartButtonClick);

    $(document).on("click", ".js-mini-cart-btn-close", ajaxify.onCartButtonClick);
  },
};

  ajaxify.init();

  // Here I close the Mini cart once I click on the dark background
  $(document).on("click", ".dark-background", function () {
    $("html").removeClass("mini-cart-open");
  });

  // Quantity fields
  let quantityFieldSelector = ".js-quantity-field",
    quantityButtonSelector = ".js-quantity-button",
    quantityPickerSelector = ".js-quantity-picker",
    quantityPicker = {
      onButtonClick: function (event) {
        //alert('button clicked');
        let $button = $(this),
          $picker = $button.closest(quantityPickerSelector),
          $quantity = $picker.find(".js-quantity-field"),
          quantityValue = parseInt($quantity.val()),
          max = $quantity.attr("max") ? parseInt($quantity.attr("max")) : null;

        if (
          $button.hasClass("plus") &&
          (max === null || quantityValue + 1 <= max)
        ) {
          // do something for plus click
          $quantity.val(quantityValue + 1).change();
        } else if ($button.hasClass("minus")) {
          // do something for minus click
          $quantity.val(quantityValue - 1).change();
        }
      },

      onChange: function (event) {
        let $field = $(this),
          $picker = $field.closest(quantityPickerSelector),
          $quantityText = $picker.find(".js-quantity-text"),
          shouldDisableMinus =
            parseInt(this.value) === parseInt($field.attr("min")),
          shouldDisablePlus =
            parseInt(this.value) === parseInt($field.attr("max")),
          $minusButton = $picker.find(".js-quantity-button.minus"),
          $plusButton = $picker.find(".js-quantity-button.plus");

        $quantityText.text(this.value);

        if (shouldDisableMinus) {
          $minusButton.prop("disabled", true);
        } else if ($minusButton.prop("disabled") === true) {
          $minusButton.prop("disabled", false);
        }

        if (shouldDisablePlus) {
          $plusButton.prop("disabled", true);
        } else if ($plusButton.prop("disabled") === true) {
          $plusButton.prop("disabled", false);
        }
      },

      init: function () {
        $(document).on(
          "click",
          quantityButtonSelector,
          quantityPicker.onButtonClick
        );
        $(document).on(
          "change",
          quantityFieldSelector,
          quantityPicker.onChange
        );
      },

    
    };

  quantityPicker.init();



$(document).ready(function () {
  let $form = $('.quantity-picker-product'),
      $quantity = $form.find('.js-quantity-field-new'),
      $plusButton = $form.find('.js-quantity-button-product.plus'),
      $minusButton = $form.find('.js-quantity-button-product.minus');

  // Function to update max attribute of quantity input field based on selectedVariant
  function updateMaxQuantity(selectedVariant) {
    if (selectedVariant) {
      $quantity.attr('max', selectedVariant.inventory_quantity);
    } else {
      $quantity.attr('max', 1); // Set max to 1 if no variant selected
    }
  }

  // Function to update quantity buttons state
  function updateQuantityButtonsState() {
    let availableStock = parseInt($quantity.attr('max'));
    let quantityValue = parseInt($quantity.val());

    $plusButton.prop('disabled', quantityValue >= availableStock);
    $minusButton.prop('disabled', quantityValue <= 1);

    let $quantityTextNew = $form.find('.js-quantity-text-new');
    $quantityTextNew.text(quantityValue);
  }

  // Initialize quantity buttons state
  updateQuantityButtonsState();

  // Plus button click event
  $plusButton.on('click', function () {
    let availableStock = parseInt($quantity.attr('max'));
    let quantityValue = parseInt($quantity.val());

    if (quantityValue < availableStock) {
      $quantity.val(quantityValue + 1);
      updateQuantityButtonsState();
    }
  });

  // Minus button click event
  $minusButton.on('click', function () {
    let quantityValue = parseInt($quantity.val());

    if (quantityValue > 1) {
      $quantity.val(quantityValue - 1);
      updateQuantityButtonsState();
    }
  });

  // Quantity field change event
  $quantity.on('change', function () {
    let newQuantity = parseInt($(this).val());
    let availableStock = parseInt($quantity.attr('max'));

    if (!isNaN(newQuantity) && newQuantity >= 1 && newQuantity <= availableStock) {
      $(this).val(newQuantity);
    } else {
      $(this).val(1);
    }

    updateQuantityButtonsState();
  });

  // Event listener for variant change
  $(document).on('form:change', addToCartFormSelector, function (event, selectedVariant) {
    $quantity.val(1); // Reset quantity field to 1 when product options change
    updateMaxQuantity(selectedVariant);
    updateQuantityButtonsState();
  });
});


// End of new code

  // Line Item 
  let removeLineSelector = ".js-remove-line",
    lineQuantitySelector = ".js-line-quantity";
  
  let lineItem = {
    isInMiniCart: function (element) {
      let $element = $(element),
        $miniCart = $element.closest(miniCartContentSelector),
        isInMiniCart = $miniCart.length != 0;

      return isInMiniCart;
    },

    isInCartPage: function (element) {
      return $(element).closest('.js-cart-page-contents').length !== 0;
    },

    onLineQuantityChanged: function (event) {
      let
        quantity = this.value,
        id = $(this).attr("id").replace("updates_", '');
      (changes = {
        quantity: quantity,
        id: id,
      }),
        console.log(quantity, id);

      (isInMiniCart = lineItem.isInMiniCart(this));

      if (isInMiniCart) {
        $.post("/cart/change.js", changes, ajaxify.onCartUpdated, "json");
      } else if (lineItem.isInCartPage(this)) {
        $.post("/cart/change.js", changes, function () {
          window.location.reload();
        }, "json");
      }
    },

    onLineRemoved: function (event) {
      let isInMiniCart = lineItem.isInMiniCart(this);

      if (isInMiniCart) {
        event.preventDefault();

        let $removeLink = $(this),
          removeQuery = $removeLink.attr("href").split("change?")[1];
        $.post("/cart/change.js", removeQuery, ajaxify.onCartUpdated, "json");
      }
    },

    init: function () {
      $(document).on("click", removeLineSelector, lineItem.onLineRemoved);
      $(document).on(
        "change",
        lineQuantitySelector,
        lineItem.onLineQuantityChanged
      );
    },
  };

  lineItem.init(); 
});













